import { call, all } from "redux-saga/effects";
import { infoSagas } from "./info/info.saga";
import { themeSagas } from "./theme/theme.saga";
import { userSagas } from "./user/user.saga";
import { marketSagas } from "./market/market.saga";

export function* rootSaga() {
  yield all([call(userSagas), call(infoSagas), call(themeSagas), call(marketSagas)]);
}
